import React, { FC } from 'react';

interface KnowMoreCardInterface extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  link: string;
  text: string;
}

const KnowMoreCard: FC<KnowMoreCardInterface> = ({ link, text, onClick }) => {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener"
      className="font-semibold text-sm leading-6 text-support2-medium hover:text-support2-dark cursor-pointer px-8 py-4"
      onClick={onClick}
    >
      {text}
    </a>
  );
};

export default KnowMoreCard;
